export const PERSISTENT_PLAYER_HOME_SELECTOR =
    "persistent-player-inner-container";

export const PERSISTENT_PLAYER_SELECTOR = "persistent-player";
export const PERSISTENT_PLAYER_PHOENIX_CONTAINER = "pp-phoenix-container";

/** Media Aspect Ratios */
export const AUDIO_ASPECT_RATIO = 4.85;
export const VIDEO_ASPECT_RATIOS = new Proxy(
    {
        "16:9": 1.7778,
        "9:16": 0.5625,
    },
    {
        get: (target, key) => {
            // WPP-888 Special identifier to opt-in to the player
            // filling its container. Checkout the README for more about
            // this and when it should be used
            if (key === "0x0") {
                return null;
            }

            // Default to 16:9 aspect ratio if the key is not found
            return target[key] ?? 1.7778;
        },
    }
);

export const PHOENIX_ELEMENT_NAME = "phoenix-player";

export const PHOENIX_PLAYER_MAX_HEIGHT = 800;

export const KEY_CODES = {
    TAB: "Tab",
    ESCAPE: "Escape",
};

export const DAI_MEDIA_TYPE = "platform-dai";
